<router-outlet></router-outlet>
@if (showLoader) {
  <div class="bw-loading-overlay">
    <span class="k-i-loading"></span>
  </div>
}

@if (showSessionExpiryPopup && !showConcurrentPopup && !isLoginPage()) {
  <div class="session-expiry-blocker">
    <div class="sessionExpiryPopup">
      <kendo-dialog (close)="saveModalAction()" [width]="420" [height]="'auto'">
        <kendo-dialog-titlebar>
          <img class="me-md-2" [src]="'assets/images/hourglass.svg'" />
          <p class="session-title">Session Expired</p>
        </kendo-dialog-titlebar>
        <div class="text-center divider-top"></div>
        <div class="customContent">
          <p class="session-message-login">Your session has timed out due to inactivity. Please log in again to resume your work.</p>
        </div>
        <div class="text-center divider-bottom"></div>
        <kendo-dialog-actions>
          <div class="cancel-btn">
            <button [className]="'btn-base btn-contained bw-font-prm-medium secondary-btn-contained btn-sm me-md-4 px-4'" (click)="onCancelClickForLogin()">Login Again</button>
          </div>
        </kendo-dialog-actions>
      </kendo-dialog>
    </div>
  </div>
} @else if (showSessionExpiryPopup && !showConcurrentPopup && !isLoginPage()) {
  <div class="col-md-8 mt-5 sessionExpiryPopupOld session-expiry-blocker">
    <kendo-dialog (close)="saveModalAction()" [width]="510" [height]="'auto'">
      <kendo-dialog-titlebar>
        <p [class]="'primary-fre-clr-bse'">Session Expired</p>
      </kendo-dialog-titlebar>
      <div class="pl-2 mb-3 customContent">
        <ng-content></ng-content>
        <p class="my-auto ml-2 bw-font-sec-bold text-start">Your session has expired. You will be redirected to the login screen.</p>
      </div>
    </kendo-dialog>
  </div>
}

@if (showConcurrentPopup && !isLoginPage()) {
  <div class="concurrent-session-expiry-blocker">
    <div class="concurrent-sessionExpiryPopup">
      <kendo-dialog class="confirmation-dialog" [width]="527" [height]="272" (close)="saveModalAction()">
        <kendo-dialog-titlebar class="pop-up-bar-v2">
          <div class="dialog-header">
            <span class="warning-icon">
              <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.692 15.3721L12.4449 1.12207C12.2471 0.780801 11.963 0.497514 11.6212 0.300585C11.2794 0.103656 10.8919 0 10.4974 0C10.1029 0 9.7154 0.103656 9.3736 0.300585C9.03181 0.497514 8.74776 0.780801 8.54991 1.12207L0.302837 15.3721C0.104832 15.714 0.00038348 16.1021 1.05394e-06 16.4973C-0.000381372 16.8924 0.103316 17.2807 0.300659 17.623C0.498001 17.9654 0.782029 18.2497 1.12416 18.4474C1.46629 18.6451 1.85446 18.7492 2.24961 18.7493H18.7452C19.1404 18.7492 19.5285 18.6451 19.8707 18.4474C20.2128 18.2497 20.4968 17.9654 20.6942 17.623C20.8915 17.2807 20.9952 16.8924 20.9948 16.4973C20.9944 16.1021 20.89 15.714 20.692 15.3721ZM9.74668 6.75C9.74668 6.55108 9.8257 6.36032 9.96635 6.21967C10.107 6.07902 10.2978 6 10.4967 6C10.6956 6 10.8864 6.07902 11.027 6.21967C11.1677 6.36032 11.2467 6.55108 11.2467 6.75V11.25C11.2467 11.4489 11.1677 11.6397 11.027 11.7803C10.8864 11.921 10.6956 12 10.4967 12C10.2978 12 10.107 11.921 9.96635 11.7803C9.8257 11.6397 9.74668 11.4489 9.74668 11.25V6.75ZM10.4972 15.7503C10.2747 15.7503 10.0572 15.6843 9.87222 15.5607C9.68721 15.4371 9.54302 15.2614 9.45787 15.0558C9.37272 14.8502 9.35044 14.624 9.39385 14.4058C9.43726 14.1876 9.5444 13.9871 9.70174 13.8298C9.85907 13.6724 10.0595 13.5653 10.2778 13.5219C10.496 13.4785 10.7222 13.5008 10.9278 13.5859C11.1333 13.6711 11.309 13.8152 11.4326 14.0003C11.5563 14.1853 11.6222 14.4028 11.6222 14.6253C11.6222 14.9236 11.5037 15.2098 11.2927 15.4207C11.0817 15.6317 10.7956 15.7503 10.4972 15.7503Z"
                  fill="#FF3700" />
              </svg>
            </span>

            <div class="dialog-header-text">You've been signed out</div>
          </div>
        </kendo-dialog-titlebar>

        <div class="dialog-body">
          <span class="custom-message"> Your account was signed in on another device or browser. </span>

          <span class="custom-warning-message">To protect your account, only one BoardWorks session can be active at a time.</span>
        </div>

        <kendo-dialog-actions>
          <div class="popup-footer-container">
            <button class="bw-btn-v2" [class.bw-btn-v2--filled]="true" (click)="onConcurrentConfirm()">
              <span class="bw-btn-start">
                <ng-content select="[slot=start]"></ng-content>
              </span>
              <span class="bw-btn-label"> Return to Login </span>
            </button>
          </div>
        </kendo-dialog-actions>
      </kendo-dialog>
    </div>
  </div>
}

@if (showSessionExpiringTimerPopup && !showConcurrentPopup && !isLoginPage()) {
  <div class="session-expiry-blocker">
    <div class="sessionExpiryPopup">
      <kendo-dialog (close)="saveModalAction()" [width]="420" [height]="'auto'">
        <kendo-dialog-titlebar>
          <img class="me-md-2" [src]="'assets/images/hourglass.svg'" />
          <p class="session-title">Session Expiring Soon</p>
        </kendo-dialog-titlebar>
        <div class="text-center divider-top"></div>
        <div class="customContent">
          <p class="session-message">
            Your session will expire in <b>{{ timeLeft }}</b> minute(s) due to inactivity
          </p>
        </div>
        <div class="text-center divider-bottom"></div>
        <kendo-dialog-actions>
          <div class="session-popup-action-btn">
            <div class="cancel-btn">
              <button [className]="'btn-base secondary-btn-text border-secondary bw-font-prm-medium btn-sm me-md-4 px-4 btn-sm me-md-4 px-4 session-logout-now-btn'" (click)="onCancelClick()">
                Logout Now
              </button>
            </div>
            <div class="cancel-btn">
              <button [className]="'btn-base btn-contained bw-font-prm-medium secondary-btn-contained btn-sm px-4'" (click)="stayLoggedInClick()">Stay Logged In</button>
            </div>
          </div>
        </kendo-dialog-actions>
      </kendo-dialog>
    </div>
  </div>
}

